function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

/* eslint-disable max-params */
import { createElement, Component } from 'react';
import getDisplayName from 'react-display-name';

var safeTimerFactory = function safeTimerFactory(setFn, clearFn, propName, hocName) {
  return function (Target) {
    var SafeTimer =
    /*#__PURE__*/
    function (_Component) {
      _inherits(SafeTimer, _Component);

      function SafeTimer(props, context) {
        var _this;

        _classCallCheck(this, SafeTimer);

        _this = _possibleConstructorReturn(this, _getPrototypeOf(SafeTimer).call(this, props, context));
        _this.unsubscribers = [];
        _this[propName] = _this[propName].bind(_assertThisInitialized(_assertThisInitialized(_this)));
        return _this;
      }

      _createClass(SafeTimer, [{
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          this.unsubscribers.forEach(function (unsubscribe) {
            return unsubscribe();
          });
          this.unsubscribers = [];
        }
      }, {
        key: propName,
        value: function value() {
          var id = setFn.apply(void 0, arguments);

          var unsubscriber = function unsubscriber() {
            return clearFn(id);
          };

          this.unsubscribers.push(unsubscriber);
          return unsubscriber;
        }
      }, {
        key: "render",
        value: function render() {
          return createElement(Target, _objectSpread({}, this.props, _defineProperty({}, propName, this[propName])));
        }
      }]);

      return SafeTimer;
    }(Component);

    if (process.env.NODE_ENV !== 'production') {
      SafeTimer.displayName = "".concat(hocName, "(").concat(getDisplayName(Target), ")");
    }

    return SafeTimer;
  };
};

export default safeTimerFactory;